import { useState } from 'react'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import parcelServices from '@/parcels/services/services'

import { getCarriersInfo } from './helpers'

const useRequestPickupDrawer = ({ storeId, carriers, setToastInfo, refetch }) => {
  const [showRequestPickupDrawer, setShowRequestPickupDrawer] = useState(false)
  const [selectedCarriers, setSelectedCarriers] = useState([])
  const [selectedLocationId, setSelectedLocationId] = useState(null)

  const {
    fetchData,
    loading: loadingCarriersToPickup,
    data: carriersToPickup,
  } = useFetch(parcelServices.getCarriersByParcelStatus, {
    doInitialRequest: false,
  })

  const { fetchData: fetchSchedulePickups, loading: loadingSchedulePickups } = useFetch(
    parcelServices.schedulePickups,
    {
      doInitialRequest: false,
    }
  )

  const openRequestPickupDrawer = () => {
    setShowRequestPickupDrawer(true)
    fetchData({ storeId, status: shipmentStatuses.ready })
  }

  const closeRequestPickupDrawer = () => {
    setShowRequestPickupDrawer(false)
    setSelectedCarriers([])
    setSelectedLocationId(null)
  }

  const handleChangeLocation = locationId => {
    setSelectedLocationId(locationId)
    fetchData({ storeId, status: shipmentStatuses.ready, locationId: locationId === 'all' ? undefined : locationId })
  }

  const handleCheckCarrier = carrierId => {
    if (selectedCarriers.includes(carrierId)) {
      setSelectedCarriers(selectedCarriers.filter(id => id !== carrierId))
    } else {
      setSelectedCarriers([...selectedCarriers, carrierId])
    }
  }

  const getTotalShipments = () => {
    if (carriersToPickup?.length) {
      return carriersToPickup.reduce((acc, carrier) => acc + carrier?.shipment_count, 0)
    }
    return 0
  }

  const schedulePickups = async () => {
    try {
      const payload = {
        carrier_ids: selectedCarriers,
        ...(selectedLocationId && selectedLocationId !== 'all' && { location_id: selectedLocationId }),
      }
      await fetchSchedulePickups({ storeId, payload })
      await refetch()
      closeRequestPickupDrawer()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showRequestPickupDrawer,
    openRequestPickupDrawer,
    closeRequestPickupDrawer,
    carriersToPickup: getCarriersInfo(carriersToPickup, carriers),
    loadingCarriersToPickup,
    selectedCarriers,
    handleCheckCarrier,
    totalShipmentsCount: getTotalShipments(),
    schedulePickups,
    loadingSchedulePickups,
    selectedLocationId,
    handleChangeLocation,
  }
}

export default useRequestPickupDrawer
